import { render, staticRenderFns } from "./RefundComponent.vue?vue&type=template&id=6ba46b26&"
import script from "./RefundComponent.vue?vue&type=script&lang=js&"
export * from "./RefundComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports